// extracted by mini-css-extract-plugin
export default {"hideTooltip":"O9-z","fadeIn":"P9-z","delay":"Q9-z","recommendedSizeTooltip":"R9-z"};